import { Component, Input } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { OrderService, AuthenticationService, SiteService } from '@app/_services';
import { ToastrService } from 'ngx-toastr';
import { Payments } from '@app/_models';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { BenefitPayDialogComponent } from '@app/shared/components/benefit-pay-dialog/benefit-pay-dialog.component';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { TranslateHelper } from '@app/_helpers';
import * as _ from 'lodash';
import { MatDialog as MatDialog } from '@angular/material/dialog';
import { CancelReasonsDialogComponent } from './componenet/cancel-order-dialog/cancel-order-dialog.component';
import { ReturnReasonsDialogComponent } from './componenet/return-order-dialog/return-order-dialog.component';
import { CurrencyFormatPipe } from '../../../../../../shared/pipes/currency-format.pipe';
import { OrderMessageComponent } from './componenet/message-information/order-messages.component';
import { MatBadgeModule } from '@angular/material/badge';
import { MatTabsModule } from '@angular/material/tabs';
import { OptionsDetailsViewerComponent } from '../../../../../../shared/components/options-details/options-details.component';
import { BookingDetailsViewerComponent } from '../../../../../../shared/components/booking-details/booking-details.component';
import { CancelOrderInformationComponent } from './componenet/cancel-order-information/cancel-order-information.component';
import { ReturnOrderInformationComponent } from './componenet/return-order-information/return-order-information.component';
import { MatDividerModule } from '@angular/material/divider';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { CurrencyConvertPipe } from '@app/shared/pipes';

@Component({
    selector: 'app-vendor-order-details',
    templateUrl: './order-details.component.html',
    styleUrls: ['./order-details.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgIf, RouterLink, MatDividerModule, ReturnOrderInformationComponent, CancelOrderInformationComponent, NgFor, BookingDetailsViewerComponent, OptionsDetailsViewerComponent, MatTabsModule, MatBadgeModule, OrderMessageComponent, DatePipe, CurrencyFormatPipe, TranslateModule, CurrencyConvertPipe]
})
export class PageVendorOrderDetailsComponent {
    constructor(private route: ActivatedRoute,
        private orderService: OrderService,
        private authService: AuthenticationService,
        private toastr: ToastrService,
        private dialog: MatDialog,
        private modalService: BsModalService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        public siteService: SiteService) { }


    @Input() order;
    @Input() isGuest;
    orderId;
    userDetails;
    paidStatuses = Payments.getPaidStatuses();
    bsModalRef: BsModalRef;
    groupProducts=[];
    ngOnInit(): void {
        this.authService.currentUser.subscribe(user => {
            this.userDetails = user;
        });
        this.route.params.subscribe((params) => {
            this.orderId = params['orderId'];
        });
        this.createGroupProducts(this.order?.groups)

    }

    printOrder() {
        return this.orderService.printOrderUrl(this.orderId);
    }
    payWithBenefit(){
        const initialState = {
            order: this.order
        };
        this.bsModalRef = this.modalService.show(BenefitPayDialogComponent, {
            initialState, ignoreBackdropClick: true
        });
    }
    createGroupProducts(groups) {
        if (_.isEmpty(groups)) return;

        _.forEach(groups, (group, groupIndex) => {
            this.groupProducts[groupIndex] = [];
            let groupArray = this.groupProducts[groupIndex];
            if (group.itemIds) {
                _.forEach(group.itemIds, itemId => {
                    let item = _.find(this.order.items, ['itemId', itemId]);
                    if (item) {
                        this.groupProducts[groupIndex].push(item.product)
                    }
                });
            }
        });

    }

    cancelRequest() {
        this.orderService.cancelOrder({})
    }

    openCancelDialog() {

        this.dialog.open(CancelReasonsDialogComponent, { data: this.order }).afterClosed().subscribe(value => {
            if (value) {
                this.orderService.cancelOrder(value).subscribe((res=>{
                    if (res.code == 200) {
                        this.order = res.data;
                        this.toastr.show(res.msg);
                    }
                    else this.toastr.error(res.msg || "Error cancelling Order.");
                }))
            }
        });
    }

    openReturnDialog() {

        this.dialog.open(ReturnReasonsDialogComponent, { data: this.order, width: '80%' }).afterClosed().subscribe(value => {
            if (value) {
                this.orderService.returnOrder(value).subscribe((res=>{
                    if (res.code == 200) {
                        this.order = res.data;
                        this.toastr.show(res.msg);
                    }
                    else this.toastr.error(res.msg || "Error requesting Return Order.");
                }))
            }
        });
    }

    selectedChange(tab) {
        if (tab != 1 || !this.order?.unreadUserMessages) return;
        this.orderService.readCommunications(this.order?.orderId).subscribe((response)=>{
            if (response.code == 200) this.order.unreadUserMessages = false;
        });
    }
}
